import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileuploadprogressService {
  uploadProgress = new Subject<string>();
  constructor() { }
}
